// extracted by mini-css-extract-plugin
module.exports = {"reportDivider":"ReportTableListPlatinumPlus_reportDivider__2jU6s"};